export const USER = "user";

export interface InitialState {
  userId: string | null;
  firstName: string;
  middleName: string;
  lastName: string;
  email: string;
  number: string;
  address: string;
  token: string | null;
  description: string;
  memberSince: string;
}

export interface Reducers {
  [key: string]: (state: InitialState, action: any) => void;
}

export type UserType = {
  firstName: string;
  lastName: string;
  number: string;
  address: string;
};
